module.exports = __webpack_public_path__ + "img/close-arrow-white.0c41ba48.svg";